import { axiosSakusas } from "../axios/sakusas_axios";

export type EditableTextAddParams = {
  slug: string;
  content: string;
};

export const editableTextAdd = async ({
  slug,
  content,
}: EditableTextAddParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosSakusas.post("editable-text", { slug, content });
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const editableTextGet = async (slug: string): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosSakusas.get(`editable-text/${slug}?searchBy=slug`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const editableTextUpdate = async (
  id: string,
  updatePayload: any
): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosSakusas.put(`editable-text/${id}`, updatePayload);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};
